import { useState } from 'react';
import type { QuanLyLop as IQuanLyLop } from '@/services/QuanLyLop';
import { getThongTinHocPhiLopPageable } from '@/services/ThongTinHocPhi/thongtinhocphi';

export default () => {
  const [danhSach, setDanhSach] = useState<IQuanLyLop.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [thang, setThang] = useState<number>(new Date().getMonth());
  const [nam, setNam] = useState<number>(new Date().getFullYear());
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  // const getThongTinHocPhiLopModel = async (lopId?: string) => {
  //   setLoading(true);
  //   const response = await getThongTinHocPhiLop({ page, limit, cond, lopId });
  //   setDanhSach(response?.data?.data?.result ?? []);
  //   setTotal(response?.data?.data?.total ?? 0);
  //   setLoading(false);
  // };

  const getDSLopFromThongTinHocPhiLop = async () => {
    setLoading(true);
    if (cond?.thang === undefined || cond?.thang === null) {
      cond.thang = thang,
      cond.nam = nam
    }
    const res = await getThongTinHocPhiLopPageable({ page, limit, cond })
    setDanhSach(res?.data?.data?.result ?? []);
    setTotal(res?.data?.data?.total ?? 0);
    setLoading(false);
  }

  return {
    getDSLopFromThongTinHocPhiLop,
    danhSach,
    loading,
    setLoading,
    total,
    setTotal,
    page,
    limit,
    setPage,
    setLimit,
    cond,
    setCondition,
    thang,
    setThang,
    nam,
    setNam,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    visibleForm,
    edit,
    setEdit,
  };
};
